import {
  SERVICE_CATEGORIES,
  POPULAR_SERVICES,
  NEW_SERVICES,
  PLATFORM_STATS,
  SPECIAL_OFFERS
} from '../data/servicesData';
import {
  WEDDING_SERVICES,
  HOME_POOJA_SERVICES,
  FESTIVAL_SERVICES,
  LIFE_EVENTS_SERVICES,
  SPIRITUAL_SERVICES,
  SPECIAL_OCCASIONS_SERVICES,
  SERVICE_FILTERS,
  PAGE_CONFIGS,
  getFilteredServices
} from '../data/allServicesData';
import { normalizeServiceList } from '../config/catalog/normalizedServiceSchema';

const CATEGORY_SERVICE_MAP = {
  wedding: WEDDING_SERVICES,
  homePooja: HOME_POOJA_SERVICES,
  festival: FESTIVAL_SERVICES,
  lifeEvents: LIFE_EVENTS_SERVICES,
  spiritual: SPIRITUAL_SERVICES,
  specialOccasions: SPECIAL_OCCASIONS_SERVICES
};

const SERVICE_PAGE_MAP = {
  wedding: 'wedding-services',
  homePooja: 'home-pooja-services',
  festival: 'festival-services',
  lifeEvents: 'life-events',
  spiritual: 'spiritual-services',
  specialOccasions: 'special-occasions'
};

export const getHomeCatalog = () => {
  return {
    categories: SERVICE_CATEGORIES,
    popularServices: normalizeServiceList(POPULAR_SERVICES, { servicePage: 'most-booked-services' }),
    newServices: normalizeServiceList(NEW_SERVICES, { servicePage: 'new-services' }),
    stats: PLATFORM_STATS,
    offers: SPECIAL_OFFERS
  };
};

export const getCategoryCatalog = (serviceType) => {
  const baseServices = CATEGORY_SERVICE_MAP[serviceType] || [];
  const page = SERVICE_PAGE_MAP[serviceType] || 'home';

  return {
    services: normalizeServiceList(baseServices, { servicePage: page }),
    filters: SERVICE_FILTERS[serviceType] || [],
    pageConfig: PAGE_CONFIGS[serviceType] || null,
    filterServices: (filterId, list = baseServices) => getFilteredServices(serviceType, filterId, list)
  };
};

export default {
  getHomeCatalog,
  getCategoryCatalog
};
